import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	emptyIssues: {
		// eslint-disable-next-line jira/i18n/id-named-by-package
		id: 'native-issue-table.issue-table.empty-issues.empty-issues',
		defaultMessage: 'There are no issues',
		description: 'Message shown when no issues are available.',
	},
});
